import {makeAutoObservable, observable, reaction} from 'mobx'
import {SalesInvoiceLineDto} from "../model/invoice/sales/SalesInvoiceLineDto";
import {selectedCompanyStore} from "./SelectedCompany";
import {localStore} from "./localStore";
import {makePersistable, stopPersisting} from "mobx-persist-store";
import {dateGetter, dateSetter} from "../utils/DataFormat";


class InvoiceWizardState {
    @observable companyId?: string
    @observable selectedCustomerId?: string
    @observable _invoiceDate?: string
    @observable _dueDate?: string
    @observable customInvoiceNumber?: string
    @observable selectedCurrency?: string
    @observable readonly invoiceLines = observable<SalesInvoiceLineDto>([])
    @observable comment?: string


    constructor() {
        makeAutoObservable(this);
        makePersistable(this, {
            name: 'invoiceWizardState',
            properties: ['companyId', 'selectedCustomerId', '_invoiceDate', '_dueDate', 'customInvoiceNumber', 'selectedCurrency', 'invoiceLines', 'comment'],
            storage: localStore
        }).then(() => console.log("InvoiceWizardState hydrated"));
    }

    public stopPersisting = () => {
        stopPersisting(this)
    }

    get invoiceDate() {
        return dateGetter(this._invoiceDate)
    }

    set invoiceDate(date) {
        this._invoiceDate = dateSetter(date)
    }

    get dueDate() {
        return dateGetter(this._dueDate)
    }

    set dueDate(date) {
        this._dueDate = dateSetter(date)
    }


    public resetInvoiceWizardState = (companyId?: string) => {
        if (this.companyId !== companyId) {
            this.selectedCustomerId = undefined
            this._invoiceDate = undefined
            this._dueDate = undefined
            this.customInvoiceNumber = undefined
            this.selectedCurrency = undefined
            this.comment = undefined
            this.invoiceLines.clear()

            this.companyId = companyId ?? selectedCompanyStore.companyId;
        }
    }
}

export const invoiceWizardState = new InvoiceWizardState();

reaction(
        () => selectedCompanyStore.companyId,
        (companyId) => invoiceWizardState.resetInvoiceWizardState(companyId)
)
